import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { getInvoiceShippingQuote, getItemShippingQuoteNew } from './shippingQuote.api';
import { getShouldFetchShippingQuote } from './shippingQuote.selectors';
import { ShippingQuote } from './shippingQuote.types';

type LotShippingQuoteParams = {
    countryCode: string;
    itemId: number;
    postalCode: string;
};

type InvoiceShippingQuoteParams = {
    invoiceId: number;
};

export const fetchLotShippingQuote = createAsyncThunk<ShippingQuote, LotShippingQuoteParams>(
    'la/ui/shippingQuote/fetchLotShippingQuote',
    async ({ countryCode, itemId, postalCode }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);

            const payload = await getItemShippingQuoteNew({
                authToken,
                countryCode,
                deployment,
                itemId,
                postalCode,
            });

            return payload;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchLotShippingQuoteIfNeeded = createAsyncThunk<void, LotShippingQuoteParams>(
    'la/ui/shippingQuote/fetchLotShippingQuoteIfNeeded',
    async ({ countryCode, itemId, postalCode }, { dispatch, getState }) => {
        const state = getState();
        const shouldFetch = getShouldFetchShippingQuote(state, itemId);
        if (shouldFetch) {
            await dispatch(fetchLotShippingQuote({ countryCode, itemId, postalCode }));
        }
    }
);

export const fetchInvoiceShippingQuote = createAsyncThunk<ShippingQuote, InvoiceShippingQuoteParams>(
    'la/ui/shippingQuote/fetchInvoiceShippingQuote',
    async ({ invoiceId }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);

            const payload = await getInvoiceShippingQuote({
                authToken,
                deployment,
                invoiceId,
            });

            return payload;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchInvoiceShippingQuoteIfNeeded = createAsyncThunk<void, InvoiceShippingQuoteParams>(
    'la/ui/shippingQuote/fetchInvoiceShippingQuoteIfNeeded',
    async ({ invoiceId }, { dispatch, getState }) => {
        const state = getState();
        const shouldFetch = getShouldFetchShippingQuote(state, invoiceId);
        if (shouldFetch) {
            await dispatch(fetchInvoiceShippingQuote({ invoiceId }));
        }
    }
);
